import React from 'react';
import { connect } from 'react-redux';
import paging, { onCategoryScroll } from '@/hooks/paging';
import { presentationOptions } from '@/constants/states';
import CardsHeader from '@/components/cards/CardsHeader';
import { states } from '@/constants/lifecycle';
import VocabularyCards from '../components/VocabularyCards';
import VocabulariesFilters from './VocabulariesFilters';
import VocabulariesPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/VocabulariesPanelContainer';
import VocabulariesTable from '../components/VocabulariesTable';

const VocabulariesPanelFull = ({
  canEdit,
  category,
  currentPage,
  display,
  fetchData,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  togglePresentation,
  total,
  vocabularies,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus);

  return (
    <VocabulariesPanelContainer
      readErrors={readErrors}
      canEdit={canEdit}
      className="aridhia-vocabularies-panel-full"
    >
      {display === presentationOptions.CARDS && (
        <>
          <CardsHeader
            disabled={readStatus === states.PENDING}
            onClick={() => togglePresentation(category, presentationOptions.TABLE)}
          >
            <VocabulariesFilters category={category} className="aridhia-list-filter" />
          </CardsHeader>
          <VocabularyCards
            category={category}
            handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
            items={vocabularies}
            readErrors={readErrors}
            readStatus={readStatus}
          />
        </>
      )}
      {display !== presentationOptions.CARDS && (
      <VocabulariesTable
        category={category}
        currentPage={currentPage}
        fetchData={fetchData}
        pageCount={pageCount}
        pageSize={pageSize}
        readErrors={readErrors}
        readStatus={readStatus}
        togglePresentation={togglePresentation}
        total={total}
        vocabularies={vocabularies}
      />
      )}
    </VocabulariesPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabulariesPanelFull);
